<template lang="pug">
  .share-model(v-if="visible" @touchmove.prevent)
    .img-radius(:style='`--img-radio: ${imgRadio}; --transform-radio: ${1/imgRadio};`')
      .img-container
        .img-title 今日抽中 「{{prizeName}}」
        .share-img-icon(:style='{backgroundImage:`url(${icon})`}')
    .container
      .share-icons
        .share-icon(v-for="icon in channelsIcon" @click="goShare(icon)")
          img.icon(:src="icon.src")
          .des {{icon.des}}
      .share-separate
      .cancel-btn(@click="cancel") 取消
      .share-bottom(@click="cancel")
    .mask(@click="clickMask")
  </template>
<script>
import { Native } from '@hb/NBridge/lib/h5';
import Toast from '@/components/toast';
import { checkWXInstallation, checkXHSInstallation } from '@/utils/tools';
import { saveImageToAlbum, imageToDataURL } from '@/utils/image';
import { env } from '@hb/hbridge';

const icons = [
  {
    code: 'saveImage',
    src: 'https://assets.51downapp.cn/file-1755493721308-468041514.png',
    des: '保存图片',
  },
  {
    code: 'wechatFriend',
    src: 'https://assets.51downapp.cn/file-1755493721310-93829212.png',
    des: '微信好友',
  },
  {
    code: 'wechatMiniProgram',
    src: 'https://assets.51downapp.cn/file-1755493721310-93829212.png',
    des: '微信好友',
  },

  {
    code: 'wechatMoments',
    src: 'https://assets.51downapp.cn/file-1755493721312-68038784.png',
    des: '微信朋友圈',
  },
  {
    code: 'copyLink',
    src: 'https://assets.51downapp.cn/file-1755493721310-856366694.png',
    des: '复制链接',
  },
  {
    code: 'haCode',
    src: 'https://assets.51downapp.cn/file-1755493721310-856366694.png',
    des: '哈口令',
  },
  {
    code: 'xiaohongshu',
    src: 'https://assets.51downapp.cn/file-1755493721308-469341601.png',
    des: '小红书',
  },
];
const DEFAULT_CHANNELS_CONFIG = {
  saveImage: true, // 保存图片到相册
  wechatFriend: true, // 是否启用微信好友分享，分享给微信好友，点开后浏览器打开H5界面
  wechatMiniProgram: false, // 分享给微信好友，以小程序卡片的形式，点开后打开微信小程序
  wechatMoments: true, // 是否启用微信朋友圈分享
  copyLink: false, // 是否启用复制链接
  haCode: false, // 是否启用哈口令分享
  xiaohongshu: true, // 分享到小红书
};

/**
 * H5分享弹窗
 */
export default {
  props: {
    // 图片倍率
    imgRadio: {
      type: Number,
      required: false,
      default: 1,
    },
    // 弹窗是否可见
    visible: {
      type: Boolean,
      required: true,
      default: false,
    },
    // 中奖海报标题
    title: {
      type: String,
      required: false,
      default: '',
    },
    prizeName: {
      type: String,
      required: false,
      default: '',
    },
    // 中奖海报图标
    icon: {
      type: String,
      required: false,
      default: '',
    },
    // 分享的描述
    desc: {
      type: String,
      required: false,
      default: '',
    },
    // 分享渠道的控制开关
    channels: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    // 点击遮罩关闭弹窗
    closeOnMaskClick: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      icons,
    };
  },
  computed: {
    channelsIcon() {
      return icons.filter((item) => this.enabledChannels[item.code]);
    },
    enabledChannels() {
      return {
        ...DEFAULT_CHANNELS_CONFIG,
        ...this.channels,
      };
    },
  },
  methods: {
    clickMask() {
      if (this.closeOnMaskClick) {
        this.cancel();
      }
    },
    cancel() {
      this.$emit('close');
    },
    async checkAppInstallation(schemeUrl) {
      try {
        const checkRes = await Native.callNative({
          classMap: 'business/hitch',
          method: 'checkThirdAppInstall',
          params: { schemeUrl },
          timeout: false,
        });
        return checkRes && checkRes.install;
      } catch (error) {
        return false;
      }
    },
    async goShare(icon) {
      const wxTypes = ['wechatFriend', 'wechatMiniProgram', 'wechatMoments'];
      if (wxTypes.includes(icon.code)) {
        const isInstallWx = await checkWXInstallation();
        if (!isInstallWx) {
          Toast.show('请先安装微信客户端');
          return;
        }
      }
      if (icon.code === 'xiaohongshu') {
        const isInstallXHS = await checkXHSInstallation();
        if (!isInstallXHS) {
          Toast.show('请先安装小红书客户端');
          return;
        }
      }
      this.$emit('shareModalClick', icon.code || '');
      switch (icon.code) {
        // 微信好友
        case 'wechatFriend':
          try {
            const shareImg = await imageToDataURL({ querySelector: '.img-container', radio: this.imgRadio });
            Native.directItemShare({
              title: this.title,
              desc: this.desc,
              tapType: 1,
              mediaType: 2,
              shareImageBase64: shareImg.data,
            });
          } catch (e) {
            Toast.show('分享失败');
          }
          break;
        // 微信朋友圈
        case 'wechatMoments':
          try {
            const shareImg = await imageToDataURL({ querySelector: '.img-container', radio: this.imgRadio });
            Native.directItemShare({
              title: this.title,
              desc: this.desc,
              tapType: 2,
              mediaType: 2,
              shareImageBase64: shareImg.data,
            });
          } catch (e) {
            Toast.show('分享失败');
          }
          break;
        // 保存图片
        case 'saveImage':
          try {
            await saveImageToAlbum({ querySelector: '.img-container', radio: this.imgRadio });
          } catch (e) {
            Toast.show('图片保存失败');
          }
          break;
        // 小红书
        case 'xiaohongshu':
          try {
            const shareImg = await imageToDataURL({ querySelector: '.img-container', radio: this.imgRadio });
            if (!shareImg.success) {
              Toast.show('图片保存失败');
              return;
            }
            let shareImageBase64 = shareImg.data;
            // 安卓分享图片需要去掉data:image/jpeg;base64,（sdk的问题）
            if (env.isAndroid) {
              shareImageBase64 = shareImg.data.replace('data:image/jpeg;base64,', '');
            }
            Native.directItemShare({
              tapType: 8,
              mediaType: 2,
              title: this.title,
              desc: this.desc,
              imageUrl: '', // 兜底分享图，shareImageBase64解析失败就会取imageUrl
              shareImageBase64,
            });
          } catch (e) {
            Toast.show('分享失败', e);
          }
          break;
        default:
          break;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.share-model {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 102;

  .container {
    position: fixed;
    bottom: 0;
    width: 100%;
    background-color: #fff;
    z-index: 200;
    border-radius: 0.12rem 0.12rem 0 0;

    .share-icons {
      width: 100%;
      padding: 0.16rem 0.27rem;
      display: flex;
      justify-content: space-around;

      .share-icon {
        text-align: center;

        .icon {
          height: 0.5rem;
          width: 0.5rem;
        }

        .des {
          margin-top: 0.03rem;
          font-family: PingFangSC-Regular, PingFang SC, sans-serif;
          font-size: 0.12rem;
          font-weight: 400;
          color: #666;
        }
      }
    }

    .share-separate {
      width: 100%;
      height: 0.08rem;
      background: #f0f3f5;
    }

    .cancel-btn {
      height: 0.52rem;
      width: 100%;
      text-align: center;
      font-weight: 400;
      color: #242729;
      font-size: 0.16rem;
      font-family: PingFangSC-Regular, PingFang SC, sans-serif;
      line-height: 0.52rem;
    }

    .share-bottom {
      height: 0.34rem;
      width: 100%;
    }
  }

  .img-radius {
    width: 3.3rem;
    height: 4.4rem;
    border-radius: 0.12rem;
    overflow: hidden;
    position: fixed;
    left: 0.225rem;
    bottom: 2.2rem;
    z-index: 203;
  }

  /** 生成的dom元素需要根据倍率放大，使html2canvas生成的图片更高清 */
  .img-container {
    position: relative;
    display: block;
    width: calc(3.3rem * var(--img-radio));
    height: calc(4.4rem * var(--img-radio));
    background: url(https://m.hellobike.com/file-1755669897166-383532930.png) no-repeat center/100% 100%;
    z-index: 200;
    overflow: hidden;
    transform: scale(var(--transform-radio));
    transform-origin: left top;

    .img-title {
      color: #fff;
      font-size: calc(0.18rem * var(--img-radio));
      text-align: center;
      margin-top: calc(1.1rem * var(--img-radio));
    }

    .share-img-icon {
      height: calc(1.6rem * var(--img-radio));
      width: calc(1.6rem * var(--img-radio));
      display: block;
      margin: calc(0.16rem * var(--img-radio)) auto 0;
      background: no-repeat center/contain;
    }
  }

  .mask {
    position: fixed;
    width: 100%;
    height: 100%;
    background: #000;
    opacity: 0.7;
    left: 0;
    top: 0;
  }
}
</style>
